import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { GenericLayer } from '../../../../../shared/model/layers/generic-layer'
import { SelectionLayer } from 'src/app/shared/model/layers/selection-layer'
import { LayerReference } from '../layer-groups.model'

@Component({
    selector: 'app-layer-group-item',
    templateUrl: './layer-group-item.component.html',
    styleUrls: ['./layer-group-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayerGroupItemComponent {
    @Input() layer: GenericLayer | SelectionLayer

    @Output() selectLayer = new EventEmitter<LayerReference>()

    selectLayerClicked(layer: GenericLayer, elementId: string): void {
        this.selectLayer.emit({ layer, elementId })
    }

    toggleLayerVisibility(event: MouseEvent, layer: GenericLayer): void {
        layer.toggleVisible()
        event.stopPropagation()
    }

    isSelectionLayer(layer: GenericLayer | SelectionLayer): layer is SelectionLayer {
        return (layer as SelectionLayer).level !== undefined
    }
}
